// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__CS_Qh","search":"Settings_search__NWfSA","filter":"Settings_filter__1FZMg"};